import { useEffect, useState } from "react";
// import authApi from "services/authApi";
import http from "services/httpClient";

export interface UserDataItem {
  id: number;
  email: string;
  role: string;
  is_active: boolean;
  is_verified: boolean;
  date_created: string;
}

export default function useUsersDataList(refreshKey: number): UserDataItem[] {
  const [users, setUsers] = useState<UserDataItem[]>([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await http.get<UserDataItem[]>(`/users`);
        setUsers(res.data);
      } catch (err) {
        // console.error("Failed to load users:", err);
      }
    };

    fetchUsers();
  }, [refreshKey]);

  return users;
}
